/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meetings_Colleagues_EmptyInputs */



/**
* | output |
* | --- |
* | "No colleagues yet. Add one here." |
*
* @param {Meetings_Colleagues_EmptyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meetings_colleagues_empty = /** @type {((inputs?: Meetings_Colleagues_EmptyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meetings_Colleagues_EmptyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Nog geen collega's. Voeg er hier een toe.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pas encore de collègues. Ajoutez-en un ici.")
	return /** @type {LocalizedString} */ ("No colleagues yet. Add one here.")
});